import React from 'react';

export default function ReviewCard({ name, review, rating }) {
  return (
    <div className="bg-gradient-to-br from-secondary/30 to-bgMuted p-4 shadow-lg rounded-xl min-h-[14rem] min-w-[250px] max-w-[500px] flex flex-col justify-center sm:mx-8 mx-2 border border-secondary/20">
      <p className="mb-2 text-textDark h-[12rem] w-fit overflow-y-auto overflow-x-hidden [&::-webkit-scrollbar]:[width:2px]
            [&::-webkit-scrollbar-thumb]:bg-primary/50
            overflow-scroll italic">"{review}"<br/><br/> <span className="font-semibold text-primary not-italic">- {name}</span></p>
    </div>
  );
}
